/**
 * Validates that a value is a safe in-app redirect path.
 *
 * TRIL-216: used by the post-login useEffect in UserLogin.tsx to honor a
 * `from` URL preserved via react-router's location state when an
 * unauthenticated user was bounced from a protected route. The state is
 * in-memory (not URL-injectable), but we still validate defensively to
 * reject:
 * - Non-strings
 * - Paths that don't start with '/'
 * - Protocol-relative URLs (//evil.com/path) or backslash variants
 * - Embedded scheme paths in the first segment (/http://evil.com,
 *   /javascript:alert(1), /data:text/html) — rejected whether or not a `//`
 *   follows the scheme. A colon deeper in the path (e.g. /search?q=a:b) is fine.
 */
export function isSafeRedirectPath(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//') || value.startsWith('/\\')) return false;
  // Reject a leading "/<scheme>:" (RFC 3986 scheme charset) — catches
  // /javascript:, /data:, /http://, etc. before any subsequent "/".
  if (/^\/[a-z][a-z0-9+.-]*:/i.test(value)) return false;
  return true;
}
